import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import css from './IconChevron.module.css';

const LEFT = 'left';
const RIGHT = 'right';
const UP = 'up';
const DOWN = 'down';

const IconChevron = props => {
  const { rootClassName, className, position = 'left' } = props;
  const classes = classNames(rootClassName || css.root, className);
  if (position === LEFT) {
    return (
      <svg
        className={classes}
        width="16"
        height="16"
        viewBox="0 0 28 28"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M20.727.297a.89.89 0 0 0-1.232-.083l-.088.083L7.25 13.32a1 1 0 0 0 0 1.364l12.157 13.023a.89.89 0 0 0 1.32 0c.336-.36.362-.928.077-1.32l-.077-.094L9.254 14 20.727 1.71c.336-.36.362-.928.077-1.32z"
          fill="currentColor"
        />
      </svg>
    );
  } else if (position === RIGHT) {
    return (
      <svg
        className={classes}
        width="16"
        height="16"
        viewBox="0 0 28 28"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M7.273.297A.89.89 0 0 1 8.505.214l.088.083L20.75 13.32a1 1 0 0 1 0 1.364L8.593 27.707a.89.89 0 0 1-1.32 0 1.05 1.05 0 0 1-.077-1.32l.077-.094L18.746 14 7.273 1.71A1.05 1.05 0 0 1 7.196.39z"
          fill="currentColor"
        />
      </svg>
    );
  } else if (position === UP) {
    return (
      <svg
        className={classes}
        width="16"
        height="16"
        viewBox="0 0 28 28"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M27.707 20.732a.89.89 0 0 0 .083-1.233l-.083-.087L14.682 7.255a1 1 0 0 0-1.364 0L.293 19.412a.89.89 0 0 0 0 1.32c.36.336.928.362 1.32.077l.094-.078L14.001 9.259l12.292 11.474c.36.336.928.362 1.32.077z"
          fill="currentColor"
        />
      </svg>
    );
  } else if (position === DOWN) {
    return (
      <svg
        className={classes}
        width="16"
        height="16"
        viewBox="0 0 28 28"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M27.707 7.278c.36.337.388.866.083 1.232l-.083.088-13.025 12.157a1 1 0 0 1-1.364 0L.293 8.598a.89.89 0 0 1 0-1.32c.36-.336.928-.362 1.32-.077l.094.077 12.294 11.474L26.293 7.278c.36-.336.928-.362 1.32-.077z"
          fill="currentColor"
        />
      </svg>
    );
  }
};

IconChevron.defaultProps = {
  rootClassName: null,
  className: null,
  position: 'left',
};

const { string } = PropTypes;

IconChevron.propTypes = {
  rootClassName: string,
  className: string,
  position: string,
};

export default IconChevron;
